import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=91b25382&"
import script from "./Batches.vue?vue&type=script&lang=js&"
export * from "./Batches.vue?vue&type=script&lang=js&"
import style0 from "./Batches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports